export default {
  model (resource) {
    return Object.assign({
      subject: ''
    }, resource)
  },
  rules () {
    return {
      subject: [
        {required: true, message: 'El asunto es requerido'},
        {min: 1, max: 50, message: 'El contenido debe ser entre 1 y 50 carácteres'}
      ]
    }
  }
}



// WEBPACK FOOTER //
// ./src/models/campaigns/campaign-subject-model.js